/**
* In Edit Physician function is used to edit the physician profile and it's functions declare this file
**/
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import * as Yup from 'yup';
import { validate, findDuplicateIndices,checkScheduleOverlap } from './../../services/ValidationService';
import ApiService from './../../services/ApiService';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ImageCroper from './../../shared/modals/ImageCroper'
import SelectedPrescriptionTemplate from '../../shared/modals/SelectedPrescriptionTemplate';
import { dataURItoBlob, filterGeoLocation, goBack, convertDateToTime, convert_DateToTime,convertTimeToDate, convertS3privateToPublic, getCountryCodeFromDialCode,handleBookedAppointmentCheck,flatPickerFormatDate } from './../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import TimezoneSelect from 'react-timezone-select';
import { DatePicker } from 'rsuite';
import "rsuite/dist/rsuite-no-reset.min.css";
import moment from 'moment';
import AllAppointmentsCancelModal from './../../shared/modals/AllAppointmentsCancelModal'
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';
import { Modal,Button, Accordion } from 'react-bootstrap';
import Pagination from './Pagination';

function EditPhysician() {

	//Intial state declaration
	let { id } = useParams();
	let  originalPhysicianId  = id;
	let hospitalData = null;
	const [loadedHospitalData, setLoadedHospitalData] = useState(null);
	const [data, setData] = useState({ out_of_office: ['["",""]']});
	const [error, setError] = useState({});
	const [users, setUser] = useState({});
	const [isValid, setIsValid] = useState(true);
	const [image, setImage] = useState('');
	const [tab, setTab] = useState(0);
	const [hospitalInfo, setHospitalInfo] = useState([{ physician: id, days:[], startTime: '', endTime: ''}]);
	// const [hospitalInfoForUI, setHospitalInfoForUI] = useState([{ physician: id, days:[], startTime: '', endTime: ''}]);
	const [parentInfo, setParentInfo] = useState([{ physician: id, parent: '', hospital: '' }]);
	const [parentInfoForUI, setParentInfoForUI] = useState([{ physician: id, parent: '', hospital: '' }]);
	const [errorHospital, setHospitalError] = useState({})
	const [errorParent, setParentError] = useState({});
	const navigate = useNavigate();
	const [show, setShow] = useState(false);
	const [cropImge, setCropImage] = useState();
	const [dublicateInfo, setDublicateInfo] = useState([]);
	const role = Number(localStorage.getItem('role'));
	const [isTimeZoneChanged, setIsTimeZoneChanged] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);
	const [modalModule, setModalModule] = useState('');
	const [bookedAppointments, setBookedAppointments] = useState([]);
	const startflatpickrRef = useRef([]);
	const endflatpickrRef = useRef([]);
	const [valueToRemove, setValueToRemove] = useState(null); // State to hold the value to remove
	const [indexValue, setIndexValue] = useState(null); // State to hold the value to remove
	const { t } = useTranslation();
	const [modal,setModal]=useState({});
	
	// New state variables for the redesigned Parent Info tab
	const [mappedParentsTable, setMappedParentsTable] = useState({ page: 0, limit: 10, search: '' });
	const [unmappedParentsTable, setUnmappedParentsTable] = useState({ page: 0, limit: 10, search: '' });
	const [showAddParentModal, setShowAddParentModal] = useState(false);
	const [selectedUnmappedParents, setSelectedUnmappedParents] = useState([]);
	// Locally track parents removed from mapped list so they appear in the Add Parent modal
	const [locallyUnmappedParents, setLocallyUnmappedParents] = useState([]);

	useEffect(() => {
		if (role === 3 && loadedHospitalData) {
		
			// Update hospital value for all objects in parentInfo
			const updatedParentInfo = parentInfo.map((item) => ({
				...item,
				hospital: loadedHospitalData.id,
			}));
		
			 setParentInfo(updatedParentInfo); // Update the state
		}
	}, [parentInfo]); // This will run whenever parentInfo changes

	useEffect(() => {
		if (users?.hospital?.length === 1) {
			// Automatically set the hospital when only one hospital is available
			const selectedHospital = users?.hospital[0];
			const updatedHospitalInfo = hospitalInfo.map((item) => ({
				...item,
				hospital: selectedHospital.id, // Set the hospital ID directly
			}));
			setHospitalInfo(updatedHospitalInfo); // Update the state with the selected hospital
			//setParentInfo(updatedHospitalInfo);
		}
	}, [users?.hospital]); // This effect will run when `users?.hospital` changes

	// New state for system timezone
	const [systemTimeZone, setSystemTimeZone] = useState('');

	// Set the system's timezone when the component mounts
	useEffect(() => {
		const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		setSystemTimeZone(systemTimeZone);

		// Initialize hospitalInfo with system timezone if empty
		setHospitalInfo((prevInfo) => prevInfo.map(item => ({
			...item,
			timeZone: item.timeZone || systemTimeZone
		})));
	}, []);

	const checkScheduleOverlaps = (existingSchedules, newSchedule, indexToExclude) => {
			const { days, startTime, endTime, physician } = newSchedule;
	
			// Convert the new schedule start and end times to moment objects
			const newStartTime = moment(startTime, "HH:mm");
			const newEndTime = moment(endTime, "HH:mm");
	
			// Loop through each existing schedule to check for overlaps
			return existingSchedules.some((schedule, index) => {
				// Skip the current schedule if its index matches the one we are adding/editing
				if (index === indexToExclude) return false;
	
				const scheduleDays = schedule.days;  // Days of the existing schedule
				const scheduleStartTime = moment(schedule.startTime, "HH:mm");  // Start time of the existing schedule
				const scheduleEndTime = moment(schedule.endTime, "HH:mm");  // End time of the existing schedule
	
				// Check if the physicians are the same
				//const samePhysician = schedule.physician === physician;
	
				// Check if there is any overlap in days
				const hasOverlapDays = days.some(day => scheduleDays.includes(day));
	
				// Check if the times overlap
				const timeConflict = newStartTime.isBefore(scheduleEndTime) && newEndTime.isAfter(scheduleStartTime);
	
				// Ensure both the days and the times must overlap for the conflict to be true
				return hasOverlapDays && timeConflict;
			});
		};
	/** 
	* To handle changeTimeZone
	* @timezone - we pass the timezone value in utc format
	* @index - we pass the index number
	**/
	// const changeTimeZone = async (timezone, index) => {
	// 	const updateArr = hospitalInfo.map((item, i) => {
	// 		if (index === i) {
	// 			return { ...item, timeZone: timezone.value };
	// 		} else {
	// 			return item;
	// 		}
	// 	});
	// 	setHospitalInfo(updateArr);
	// 	const Errors = await validate({ 'hospitalInfo': updateArr }, hosFields);
	// 	setHospitalError(Errors);
	// }
	const changeTimeZone= async (timezone) =>{
		const updateArr = hospitalInfo.map((item, i) => {
			return {
				...item,
				timeZone: timezone.value, // Update consultingDuration field
			};
		});
		setIsTimeZoneChanged(true); // Mark as changed
	  	setHospitalInfo(updateArr);  

	  	const Errors = await validate({'hospitalInfo':updateArr}, hosFields);
	  	setHospitalError(Errors);
	}

	//To add hospitalInfo
	const addHospitalInfo = (index) => async (e) => {
		e.preventDefault();
		// const currentHospital = role === 4 
		// 	? hospitalInfoForUI[index]?.hospital 
		// 	: hospitalInfo[index]?.hospital;
		
		const newRow = {
			//physician: id,
			// hospital: currentHospital || '',
			days:[],
			startTime: '',
			endTime: '',
			timeZone: systemTimeZone,
			// consultingDuration: '',  
			// isHospitalLocked: !!currentHospital,
		};
	
		const existingSchedules = hospitalInfo;

		// Validate for overlaps (exclude the current row index to avoid self-checking)
		if (checkScheduleOverlaps(existingSchedules, newRow, index)) {
			setHospitalError(prev => ({
				...prev,
				[`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
			return;
		}
		// Clear the overlap error if no conflict
		setHospitalError(prev => ({
			...prev,
			[`hospitalInfo[${index}].overlap`]: "",
		}));	

			const Errors = await validate({ 'hospitalInfo': hospitalInfo }, hosFields);
			await setHospitalError(Errors);
			
			if (!Object.keys(Errors).length) {
				await setHospitalInfo(state => [...state, newRow]);
			}
		
	};
	
	//callback function
	const handleClose = () => {
		setShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
			fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	};
	const imageData = (data) => setCropImage(data);

	//validate patterns
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	/** 
	* To change Visting Time(startTime and endTime)
	* @time - we pass the utc time value
	* @index - we pass the index Number
	* @name - we pass the timeZone name
	**/
	const changeVistingTime = async (time, index, name) => {
		setIndexValue(index);
		const physician = hospitalInfo[index].physician;
			const days = hospitalInfo[index].days;
			const startTimeValue = name === 'startTime' ? convert_DateToTime(time) : hospitalInfo[index].startTime;
			const outofoffice = [];
			const timeZoneValue = hospitalInfo[0].timeZone;
			const endTimeValue = name === 'endTime' ? convert_DateToTime(time) : hospitalInfo[index].endTime;
			const consultingDuration = parseInt(hospitalInfo[0].consultingDuration, 10); // Convert consultingDuration to an integer
		
			if(name==='endTime'){
				const newEndTimeValue = convert_DateToTime(time); // New end time based on the current time
				const originalEndTimeValue = hospitalInfo[index].endTime; // Existing end time
			
				// Adjust newEndTimeValue by subtracting consultingDuration minutes
				let adjustedNewEndTimeValue = moment(newEndTimeValue, 'HH:mm')
				.subtract(consultingDuration, 'minutes') // Subtract consultingDuration in minutes
				.format('HH:mm'); // Format back to HH:mm
		
				 // Initialize variables to store API responses
				 let newEndTimeAppointments = [];
				 let originalEndTimeAppointments = [];
			 
				 // Call the API with the new end time
				 const isBookedWithNewEndTime = await handleBookedAppointmentCheck(
					 physician,
					 days,
					 startTimeValue,
					 adjustedNewEndTimeValue,
					 [],
					 (appointments) => {
						 newEndTimeAppointments = appointments; // Capture the appointments
					 },
					 timeZoneValue,
					 'time'
				 );
				 // Call the API with the original end time
				 const isBookedWithOriginalEndTime = await handleBookedAppointmentCheck(
					 physician,
					 days,
					 startTimeValue,
					 originalEndTimeValue,
					 [],
					 (appointments) => {
						 originalEndTimeAppointments = appointments; // Capture the appointments
					 },
					 timeZoneValue,
					 'time'
				 );
					
				 // Compare the responses
				 if (isBookedWithNewEndTime !== isBookedWithOriginalEndTime || (newEndTimeAppointments.length !== originalEndTimeAppointments.length)) {
					 // Find missing appointments by comparing the 'id' values
					const missingAppointmentsFromNewEndTime = originalEndTimeAppointments.filter(original => 
						!newEndTimeAppointments.some(newApp => newApp.id === original.id)
					);
					const missingAppointmentsFromOriginalEndTime = newEndTimeAppointments.filter(newApp => 
						!originalEndTimeAppointments.some(original => original.id === newApp.id)
					);
					// Combine the missing appointments
					const missingAppointments = [
						...missingAppointmentsFromNewEndTime,
						...missingAppointmentsFromOriginalEndTime
					];
					// Set the missing appointments
					setBookedAppointments(missingAppointments);
					 // Show the modal if the booking status differs
					 setModalModule('time');
					 setModalVisible(true); // Show the modal
					 return; // Stop further execution
				 }	
			}
		
			let outsideTimeAppointments = [];
			const isBooked = await handleBookedAppointmentCheck(
			physician,
			days,
			startTimeValue,
			endTimeValue,
			outofoffice,
			(appointments) => {
				// Convert start and end times to Moment objects (24-hour format) for comparison
				const startMoment = moment(startTimeValue, 'HH:mm');
				const endMoment = moment(endTimeValue, 'HH:mm');
				// Filter appointments that are outside the new time range
				outsideTimeAppointments = appointments.filter((appointment) => {
				const appointmentTime = moment.utc(appointment.time); // Convert appointment time to Moment object
				const appointmentTimeFormatted = appointmentTime.format('HH:mm'); // Convert to HH:mm format for comparison
				// Convert appointmentTimeFormatted back to a moment object for comparison
				const appointmentTimeMoment = moment(appointmentTimeFormatted, 'HH:mm');
				// Compare appointment time with the new time range in HH:mm format
				return appointmentTimeMoment.isBefore(startMoment) || appointmentTimeMoment.isAfter(endMoment);
				});
				// If there are appointments outside the new time range, show the modal
				if (outsideTimeAppointments.length > 0) {
				setBookedAppointments(outsideTimeAppointments);
				setModalModule('time');
				setModalVisible(true); // Show the modal with booked appointments
				}
			},
			timeZoneValue,
			'time'
			);
			// Stop further execution if the modal logic is triggered
			if (isBooked && outsideTimeAppointments.length > 0) {
			return; // Prevent further execution if there are outside appointments
			}
		const updateArr = hospitalInfo.map((item, i) => {
			if (index === i) {
				return { ...item, [name]: convert_DateToTime(time) };
			} else {
				return item;
			}
		});

		const selectedItem = updateArr[index];
		const { startTime, endTime } = selectedItem;
		// Validation logic for startTime and endTime
		if (name === "startTime" || name === "endTime") {
			const start = moment(startTime, "HH:mm");
			const end = moment(endTime, "HH:mm");
			if (startTime && endTime) {
				if (start.isSame(end)) {
					setHospitalError((prev) => ({
						...prev,
						[`hospitalInfo[${index}].${name}`]: t('error.sameTime'),
					}));
					// Reset the specific field (e.g., startTime) if error occurs
					updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)
					// Update the state with the reset data
					
						setHospitalInfo(updateArr); // Update hospitalInfo state with the modified schedule
					
					return; // Return early if there's an error
				}
				if (start.isAfter(end)) {
					setHospitalError((prev) => ({
						...prev,
						[`hospitalInfo[${index}].${name}`]: t('error.incorrectTime'),
					}));
					// Reset the specific field (e.g., startTime) if error occurs
					updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)
					// Update the state with the reset data
						setHospitalInfo(updateArr); // Update hospitalInfo state with the modified schedule
					return; // Return early if there's an error
				}
			}
		}
	
		// Validate for overlaps after changing visiting time (exclude the current row index to avoid self-checking)
		const existingSchedules = hospitalInfo;
		const newSchedule = { ...selectedItem, [name]: convert_DateToTime(time) };
	
		// Check for schedule overlap
		if (checkScheduleOverlaps(existingSchedules, newSchedule, index)) {
			setHospitalError((prev) => ({
				...prev,
				[`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
	
			// Reset the specific field (e.g., startTime) if overlap occurs
			updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)

			// Update hospitalInfo state with the modified schedule
			setHospitalInfo(updateArr); 
			return; // Return early if there's an overlap and reset field
		}
	
		// Clear the overlap error if no conflict is found
		setHospitalError((prev) => ({
			...prev,
			[`hospitalInfo[${index}].overlap`]: "",
		}));

		await setHospitalInfo(updateArr);
		
		const Errors = await validate({ 'hospitalInfo': updateArr }, hosFields);
		setHospitalError(Errors);

	}


	/** 
	* Validation schema for Physician Fields
	* @first_name - required field and pass the physician first_name
	* @last_name - required field and pass the physician last_name
	* @email - required field and should be in correct physician email format 
	* @mobileNumber - required field and pass the physician mobileNumber
	* @specialist - required field and pass the physician specialist
	* @department - required field and pass the physician department
	* @city - required field and pass the physician city 
	* @state - required field and pass the physician state 
	* @gender - required field and pass the physician gender 
	* @zipcode - required field and pass the physician zipcode
	**/
	const phyFields = [
		{ name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
		{ 
		name: 'email', 
		validation: Yup.string()
			.email(t('error.email')) // built-in email validation
			.required(t('error.emailRequired')) 
		},
		{ name: 'mobileNumber', validation: Yup.string() },
/* 		{ name: 'department', validation: Yup.string().required(t('error.required')) }, */
		{ name: 'city', validation: Yup.string() },
		{ name: 'state', validation: Yup.string() },
		{ name: 'gender', validation: Yup.string() },
		{
		name: 'zipcode',
		validation: Yup.string()
			.nullable() // Allows the field to be nullable
			.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
		//   .test('len', constantVariables.error.zipcode, function (value) {
		// 	return !value || value.length >= 5; // Only check length if value is not empty
		//   })
		},
		{ name: 'specialist', validation: Yup.string().required(t('error.required')) },
		{
			name: 'register_number',
			validation: Yup.string().nullable()
		},
	];

	/** 
	* Hospital Validation schema 
	* @hospital - required field and pass the selected hospital name
	* @days - required field and pass the days in array format
	* @startTime - required field and pass the selected startTime value
	* @endTime - required field and pass the selected endTime value
	* @timeZone - required field and pass the selected timeZone value
	**/
	const hosFields = [
		{
			name: 'hospitalInfo', validation: Yup.array().of(
				Yup.object({
					// hospital: Yup.string().required(t('error.required')),
					days: Yup.array()
						.of(Yup.string())
						.min(1, t('common.selectAtleastOneDay'))
						.required(t('common.selectAtleastOneDay')),
					startTime: Yup.string().required(t('error.required')),
					endTime: Yup.string().required(t('error.required')),
					// consultingDuration: Yup.string().required(constantVariables.error.consultingDuration),
					//timeZone: Yup.string().required(t('error.required')),
				}))
		},
	];

	/** Parent Validation schema
	* @hospital - required field and pass the selected hospital name
	* @parent - required field and pass the selected parent name
	**/
	const parFields = [
		{
			name: 'parentInfo', validation: Yup.array().of(
				Yup.object({
					parent: Yup.string().required(t('error.required')),
					hospital: Yup.string().notRequired(),
				}))
		},
	];

	/** To handle input change event 
	* @e - we get the event details from the Change action 
	**/
	const handleChange = async (e) => {
		const { name, value } = e.target;
		e.preventDefault();
		setData({ ...data, [name]: value });
		const Errors = await validate({ [name]: value }, phyFields);
		setError({ ...error, [name]: Errors[name] });
	}


	/** To check phone number valid or not **/
	const handlePhone = async (value, country, e, formattedValue) => {
		const { format, dialCode } = country;
		setData({ ...data, countryCode: '+' + dialCode, mobileNumberWithCode: formattedValue, [e.target.name]: formattedValue.split("+" + dialCode + " ")[1], countryNameCode: country?.countryCode });
		const Errors = await validate({ [e.target.name]: formattedValue }, phyFields);
		setError({ ...error, [e.target.name]: Errors[e.target.name] });
		if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
			setIsValid(true);
		} else {
			setIsValid(false);
		}
	}


	//To remove hospitalInfo
	const removeHospitalInfo = (index) => async (e) => {
		const physician = hospitalInfo[index].physician;
		const days = hospitalInfo[index].days; 
		const startTime = hospitalInfo[index].startTime;
		const endTime = hospitalInfo[index].endTime;
		const outofoffice = []; 
		const timeZoneValue = hospitalInfo[index].timeZone;
		// Call the function to handle API request and modal trigger
		const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
		setBookedAppointments(appointments);
		setModalModule('schedule');
		setValueToRemove(hospitalInfo[index]);
		setModalVisible(true);  // Show the modal with booked appointments
		},
		timeZoneValue);
		// If the appointment is booked, don't continue with the rest of the logic
		if (isBooked) {
			return;
		}

		var removeArr = [];
			if (hospitalInfo.length !== 1) {
				removeArr = hospitalInfo.filter((i, idx) => idx !== index);
				// Update hospitalInfo state with adjusted isHospitalLocked property
				const updatedHospitalInfo = removeArr.map((item, idx) => ({
					...item,
					// isHospitalLocked: idx !== 0 // Unlock the first row, lock others
				}));
				setHospitalInfo(updatedHospitalInfo);
				filterHospital(removeArr);
			} else {
				await filterHospital([{}]);
				await setHospitalInfo([{ physician: id, days: [], startTime: '', endTime: '',hospital: hospitalInfo && hospitalInfo[0].hospital,hospital_name:hospitalInfo && hospitalInfo[0].hospital_name,consultingDuration: hospitalInfo && hospitalInfo[0].consultingDuration}]);
				await setHospitalError(await validate({ 'hospitalInfo': [] }, hosFields));
			};
		
	};

	//To set filtered hospital list for parent tab
	const filterHospital = (a) => {
		var filterHos = [...new Set(a.map(i => i.hospital))];
		var filter = parentInfo.map((item) => {
			if (!filterHos.includes(item.hospital)) {
				return { ...item, hospital: '' };
			} else {
				return item;
			}
		});
		setParentInfo(filter);

	};

	//To change city input 
	const changeCity = async (e) => {
		const { value } = e.target;
		var obj = {};
		if (value.trim().length === 0) {
			obj = { city: '', state: '' };
		} else {
			obj = { city: value };
		}
		setData((data) => ({ ...data, ...obj }));
		const Errors = await validate({ city: value }, phyFields);
		setError({ ...error, city: Errors['city'] });
	}

	//To select city input 
	const selectCity = async (e) => {
		var location = await filterGeoLocation(e);
		await setData((data) => ({ ...data, ...location }));
	}

	//To handle the hospitalInfo change
	const changeHospitalInfo = (index) => async (e) => {
		// e.preventDefault();
		setIndexValue(index);
		const { name, value, type, checked } = e.target;
		if(checked===false){
			const physician = hospitalInfo[index].physician;
			const days = [value]; // Create an array with the value
			const startTime = hospitalInfo[index].startTime;
			const endTime = hospitalInfo[index].endTime;
			const outofoffice = []; 
			const timeZoneValue = hospitalInfo[index].timeZone;
			// Call the function to handle API request and modal trigger
			const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('days');
			setModalVisible(true);  // Show the modal with booked appointments
			setValueToRemove(value); // Capture the value for later removal
			},
			timeZoneValue);
			// If the appointment is booked, don't continue with the rest of the logic
			if (isBooked) {
			return;
			}
		}	
		// Determine the correct array to use based on the role
		const currentHospitalInfo = hospitalInfo;
	
		const updateArr = currentHospitalInfo.map((item, i) => {
			if (index === i ) {
				if (type === "checkbox" && name === "DaysOptions") {
					const updatedDays = checked
						? [...item.days, value] // Add day
						: item.days.filter(day => day !== value); // Remove day
					return { ...item, days: updatedDays,
							hospital: currentHospitalInfo && currentHospitalInfo[0].hospital || "", 
							consultingDuration: currentHospitalInfo && currentHospitalInfo[0].consultingDuration || "" 
					};
				}
				return { ...item, [name]: value };
			} else {
				return item;
			}
		});

		  // Check for schedule overlap after updating the schedule
		  const newSchedule = updateArr[index];
		  const existingSchedules =  hospitalInfo;
	  
		  // Validate for overlaps (exclude the current row index to avoid self-checking)
		  if (checkScheduleOverlaps(existingSchedules, newSchedule, index)) {
			  setHospitalError(prev => ({
				  ...prev,
				  [`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			  }));
			  return;  // Return early if there's an overlap
		  }
	  
		  // Clear the overlap error if there is no conflict
		  setHospitalError(prev => ({
			  ...prev,
			  [`hospitalInfo[${index}].overlap`]: "",
		  }));	  

		
			setHospitalInfo(updateArr);
		
	
		const Errors = await validate({ hospitalInfo: updateArr }, hosFields);
		// Filter out the error for 'startTime' and 'endTime' and keep only the errors for 'days'
		const filteredErrors = Object.keys(Errors).reduce((acc, key) => {
			if (key.includes('days')) { // Include 'days' errors
			acc[key] = Errors[key];
			}
			return acc;
		}, {});
		
		// Set the filtered errors state
		setHospitalError(filteredErrors);
	};

	// Helper functions for the new Parent Info tab design
	const getMappedParents = () => {
		const mappedEntries = parentInfo || [];
		const allParents = users?.parent || [];
		const mappings = users?.parent_mapping || [];

		// Map physician's parentInfo entries to full parent details.
		// Prefer values from parentInfo (m) -> corresponding parent_mapping entry -> users.parent detail.
		const mappedParents = mappedEntries
			.map(m => {
				const parentDetail = allParents.find(p => String(p.account) === String(m.parent)) || {};
				// find mapping record for this parent if exists
				const mappingRecord = mappings.find(mp => String(mp.parent_account) === String(m.parent)) || {};
				const first_name = m.first_name || mappingRecord.first_name || parentDetail.first_name || '';
				const last_name = m.last_name || mappingRecord.last_name || parentDetail.last_name || '';
				const member_count = (m.members != null) ? m.members : (m.member_count != null ? m.member_count : (mappingRecord.members != null ? mappingRecord.members : (parentDetail.members != null ? parentDetail.members : (parentDetail.member_count || 0))));
				return {
					...parentDetail,
					account: m.parent || parentDetail.account,
					first_name,
					last_name,
					member_count,
					// Preserve any member details coming from API (array of {id,name})
					member_details: parentDetail.member_details || mappingRecord.member_details || m.member_details || []
				};
			})
			.filter(p => p && p.account);

		// Apply search filter
		const searchTerm = (mappedParentsTable.search || '').toLowerCase();
		const filteredParents = mappedParents.filter(parent => {
			const name = `${parent.first_name || ''} ${parent.last_name || ''}`.toLowerCase();
			return name.includes(searchTerm);
		});

		// Apply pagination
		const startIndex = mappedParentsTable.page * mappedParentsTable.limit;
		const endIndex = startIndex + mappedParentsTable.limit;
		const paginatedParents = filteredParents.slice(startIndex, endIndex);

		return {
			parents: paginatedParents,
			total: filteredParents.length,
			page: mappedParentsTable.page,
			limit: mappedParentsTable.limit
		};
	};

	const getUnmappedParents = () => {
		// If no search term, return empty list (do not show any parents)
		const searchTerm = (unmappedParentsTable.search || '').toLowerCase();
		if (!searchTerm) {
			return { parents: [], total: 0, page: unmappedParentsTable.page, limit: unmappedParentsTable.limit };
		}

		const mappings = users?.parent_mapping || [];
		const allParents = users?.parent || [];
		const hospitalAdminAccount = (hospitalInfo && hospitalInfo[0] && hospitalInfo[0].hospital_admin_account) || null;
		const shouldIncludeParentMapping = (m) => {
			const debugId = m.parent_account || m.parent_account === 0 ? String(m.parent_account) : '<no-account>';
			if (m.mapped_id == null) {
				const include = !!m.parent_account;
				return include;
			}
			if (m.mapped_id != null) {
				const physicianVal = (m.physician === null || m.physician === undefined) ? null : String(m.physician).trim();
				const hasPhysician = physicianVal !== null && physicianVal !== '' && physicianVal.toLowerCase() !== 'null';
				if (hasPhysician) return false;
				const createdBy = m.created_by != null ? String(m.created_by) : null;
				if (createdBy === null) {
					return !!m.parent_account;
				}
				const match = String(createdBy) === String(hospitalAdminAccount);
				if (match) {
					return true;
				}
				return false;
			}
			return false;
		};
		const unmappedEntries = mappings.filter(m => shouldIncludeParentMapping(m));
		const unmappedParents = unmappedEntries.map(m => {
			const p = allParents.find(ap => String(ap.account) === String(m.parent_account)) || {};
			return {
				account: m.parent_account,
				first_name: m.first_name || p.first_name || '',
				last_name: m.last_name || p.last_name || '',
				member_count: (m.members != null) ? m.members : (m.member_count != null ? m.member_count : (p.members != null ? p.members : (p.member_count || 0))),
				member_details: p.member_details || m.member_details || []
			};
		});
		const mergedUnmapped = [
			...unmappedParents,
			...locallyUnmappedParents.filter(lu => {
				if (unmappedParents.some(up => String(up.account) === String(lu.account))) return false;
				if (role === 3) {
					const mappingRecord = (users?.parent_mapping || []).find(mp => String(mp.parent_account) === String(lu.account));
					if (mappingRecord) {
						const phy = mappingRecord.physician != null ? String(mappingRecord.physician).trim() : null;
						if (phy && phy !== '' && phy.toLowerCase() !== 'null') {
							return false;
						}
					}
				}
				return true;
			})
		];
		const filteredParents = mergedUnmapped.filter(parent => {
			const name = `${parent.first_name || ''} ${parent.last_name || ''}`.toLowerCase();
			return name.includes(searchTerm);
		});
		const startIndex = unmappedParentsTable.page * unmappedParentsTable.limit;
		const endIndex = startIndex + unmappedParentsTable.limit;
		const paginatedParents = filteredParents.slice(startIndex, endIndex);
		return {
			parents: paginatedParents,
			total: filteredParents.length,
			page: unmappedParentsTable.page,
			limit: unmappedParentsTable.limit
		};
	};

	const handleMappedParentsSearch = (e) => {
		const { value } = e.target;
		setMappedParentsTable(prev => ({ ...prev, search: value, page: 0 }));
	};

	const handleUnmappedParentsSearch = (e) => {
		const { value } = e.target;
		setUnmappedParentsTable(prev => ({ ...prev, search: value, page: 0 }));
	};

	const handleMappedParentsPaginate = (page) => {
		setMappedParentsTable(prev => ({ ...prev, page }));
	};

	const handleUnmappedParentsPaginate = (page) => {
		setUnmappedParentsTable(prev => ({ ...prev, page }));
	};

	const removeMappedParent = async (parentAccount) => {
		// capture removed item from current parentInfo
		const removedItem = parentInfo.find(item => String(item.parent) === String(parentAccount));
		// Prepare a display object using available sources
		const allParents = users?.parent || [];
		const mappingRecord = (users?.parent_mapping || []).find(mp => String(mp.parent_account) === String(parentAccount)) || {};
		const parentDetail = allParents.find(p => String(p.account) === String(parentAccount)) || {};
		const removedDisplay = {
			account: parentAccount,
			first_name: (removedItem && (removedItem.first_name || removedItem.firstName)) || mappingRecord.first_name || parentDetail.first_name || '',
			last_name: (removedItem && (removedItem.last_name || removedItem.lastName)) || mappingRecord.last_name || parentDetail.last_name || '',
			member_count: (removedItem && (removedItem.members != null ? removedItem.members : (removedItem.member_count != null ? removedItem.member_count : null))) || mappingRecord.members || mappingRecord.member_count || parentDetail.members || parentDetail.member_count || 0,
			member_details: parentDetail.member_details || mappingRecord.member_details || removedItem?.member_details || []
		};
		// Add to locallyUnmappedParents if not already present
		setLocallyUnmappedParents(prev => {
			if (prev.some(p => String(p.account) === String(parentAccount))) return prev;
			return [...prev, removedDisplay];
		});

		const updated = parentInfo.filter(item => String(item.parent) !== String(parentAccount));
		setParentInfo(updated);
		// Also remove from parentInfoForUI to avoid re-introducing on submit (role 4)
		setParentInfoForUI(prev => Array.isArray(prev) ? prev.filter(item => String(item.parent) !== String(parentAccount)) : prev);
		const Errors = await validate({ parentInfo: updated }, parFields);
		setParentError(Errors);
	};

	const toggleUnmappedParentSelection = (parentAccount, checked) => {
		if (checked) {
			setSelectedUnmappedParents(prev => [...prev, parentAccount]);
		} else {
			setSelectedUnmappedParents(prev => prev.filter(p => p !== parentAccount));
		}
	};

	const addSelectedParents = async () => {
		const hospitals = (role === 4 && loadedHospitalData) ? [loadedHospitalData] : (users?.hospital || []);
		
		const newMappings = selectedUnmappedParents.map(parentAccount => {
			const hospitalId = role === 4 ? loadedHospitalData.id : hospitals[0]?.id;
			return {
				physician: id,
				parent: parentAccount,
				hospital: hospitalId
			};
		});
		
		const updated = [...parentInfo, ...newMappings];
		setParentInfo(updated);
		// Clear selections
		setSelectedUnmappedParents([]);
		setShowAddParentModal(false);
		// Remove any re-added parents from locallyUnmappedParents
		setLocallyUnmappedParents(prev => prev.filter(p => !selectedUnmappedParents.includes(p.account)));
		// Also remove re-added parents from parentInfoForUI (role 4)
		setParentInfoForUI(prev => Array.isArray(prev) ? prev.filter(p => !selectedUnmappedParents.includes(String(p.parent) || p.parent)) : prev);
		
		const Errors = await validate({ parentInfo: updated }, parFields);
		setParentError(Errors);
	};

	//To handel the form tabs navigation 
	const navChange = (page) => async (e) => {
		e.preventDefault();
		let Errors;
		data.gender = (data.gender || data.gender === 0 || data.gender === 1) ? data.gender : '';
		data.mobileNumber = data.mobileNumber || '';
		data.city = data.city ? data.city : '';
		data.state = data.state ? data.state : '';
		data.zipcode = data.zipcode ? data.zipcode : null;
		if (page === 0) {
			Errors = await validate(data, phyFields);
			setError(Errors);
		}
		if (page === 1) {
			if (!Object.keys(errorHospital).length) {
				Errors = {};
			} else {
				Errors = await validate({ 'hospitalInfo': hospitalInfo }, hosFields);
				setHospitalError(Errors);
			}
		}

		// Check for startDate and endDate validation errors
		const dateErrorsExist = Object.keys(error).some((key) => {
			const fieldErrors = error[key];
			return fieldErrors?.startDate || fieldErrors?.endDate;
		});

		if (!Object.keys(Errors).length && isValid === true && !dateErrorsExist) {
			await setTab(page + 1)
		}
	}

	// Change handler for modifying out_of_office dates
	const changeOutOfOfficeInfo = async(index, field, value) => {
		setIndexValue(index);
		let newOutOfOffice = []; // Initialize newOutOfOffice as an empty array
		// Extract the start and end dates from the current out_of_office value at the given index
		let currentDateRange = data.out_of_office[index];
		let dateArray = currentDateRange ? currentDateRange.replace(/[\[\]]/g, '').split(',') : [];
		// Handle the logic for modifying the startDate or endDate
		if (field === 'startDate') {
			// If startDate is being changed, update the start date and keep the existing end date
			newOutOfOffice.push(`[${flatPickerFormatDate(value)},${dateArray[1] || flatPickerFormatDate(value)}]`);
		} else if (field === 'endDate') {
			// If endDate is being changed, update the end date and keep the existing start date
			newOutOfOffice.push(`[${dateArray[0] || flatPickerFormatDate(value)},${flatPickerFormatDate(value)}]`);
		}
		const physician = data.account;
		const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		const startTime = '00:00';
		const endTime = '00:00';
		const outofoffice = newOutOfOffice;
		data.newOutOfOffice = newOutOfOffice;
			// Call the function to handle API request and modal trigger
			const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('out_of_office');
			setModalVisible(true);  // Show the modal with booked appointments
			});
			// If the appointment is booked, don't continue with the rest of the logic
			if (isBooked) {
			return;
			}

		// Create a shallow copy of the out_of_office array
		const updatedOutOfOffice = [...data.out_of_office];
		let updatedErrors = { ...error };

		if (!updatedOutOfOffice[index]) {
			updatedOutOfOffice[index] ='["", ""]';
		}
		// Ensure the entry at the given index exists
		if (updatedOutOfOffice[index]) {
		  // Check if the entry is a string, if not handle it accordingly
		  if (typeof updatedOutOfOffice[index] === 'string') {
			// Parse the string into an array [startDate, endDate]
			const dates = updatedOutOfOffice[index]
				.replace(/\[|\]/g, "") // Remove square brackets
				.split(",")
				.map((date) =>
				typeof date === "string" ? date.trim().replace(/"/g, "") : flatPickerFormatDate(date)
			);
			//.map(date => date.trim());
			
			// Update the corresponding date
			if (field === "startDate") {
			  dates[0] = flatPickerFormatDate(value); // Update the start date
			} else if (field === "endDate") {
			  dates[1] = flatPickerFormatDate(value); // Update the end date
			}
			
			// Convert the array back into a string with the desired format
			updatedOutOfOffice[index] = `[${dates[0]},${dates[1]}]`;	
			
			// Validate the updated row
			const [startDate, endDate] = dates;
			const rowErrors = {};

			if (!startDate || startDate === "") {
				rowErrors.startDate = `${t('common.startDateRequired')}`;
			}
	
			// Check if endDate is empty
			// if (!endDate || endDate === "") {
			// 	rowErrors.endDate = "End date is required.";
			// }
			
			if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
				rowErrors.startDate = `${t('common.startBeforeEnd')}`;
				// rowErrors.endDate = "End date must be later than start date.";
			}

			// Check for overlapping ranges
			if (startDate && endDate) {
                const currentStart = new Date(startDate);
                const currentEnd = new Date(endDate);

                // Validate against all rows in updatedOutOfOffice
                for (let i = 0; i < updatedOutOfOffice.length; i++) {
                    if (i === index) continue; // Skip the current row

                    const [otherStart, otherEnd] = updatedOutOfOffice[i]
                        .replace(/\[|\]/g, "")
                        .split(",")
                        .map((date) => flatPickerFormatDate(date));

                    if (otherStart && otherEnd) {
                        const otherStartDate = new Date(otherStart);
                        const otherEndDate = new Date(otherEnd);

                        // Check for range overlap
                        if (
                            (currentStart <= otherEndDate && currentEnd >= otherStartDate) ||
                            (otherStartDate <= currentEnd && otherEndDate >= currentStart)
                        ) {
                            rowErrors.startDate = `${t('common.datesExist')}`;
                            break;
                        }
                    }
                }
			}
			updatedErrors[`row_${index}`] = rowErrors;
			setError(updatedErrors);

		  } else if (Array.isArray(updatedOutOfOffice[index])) {
			// If it's an array, directly update the date values
			if (field === "startDate") {
			  updatedOutOfOffice[index][0] = flatPickerFormatDate(value); // Update the start date
			} else if (field === "endDate") {
			  updatedOutOfOffice[index][1] = flatPickerFormatDate(value); // Update the end date
			}
		  } else {
			console.error(`Unexpected data format at index ${index}`);
		  }
		} else {
		  console.error(`Entry at index ${index} does not exist in out_of_office`);
		}
		
		// Update the state with the new out_of_office array
		setData({ ...data, out_of_office: updatedOutOfOffice });
	  };
	  
	// Add a new out of office date range
	const addOutOfficeInfo = async () => {
		// Initialize validation errors object
		let newErrors = {};
		const seenRanges = []; // Track ranges to identify duplicates

		const updatedOutOfOffice = [...data.out_of_office];
		// Validate all rows before adding a new one
		updatedOutOfOffice.forEach((entry, index) => {
			const [startDate, endDate] = entry
            .replace(/\[|\]/g, "")
            .split(",")
            .map((date) => date.trim().replace(/"/g, ""));
			const rowErrors = {};
			
			// Check if startDate is empty
			if (!startDate || startDate === "") {
				rowErrors.startDate = `${t('common.startDateRequired')}`;
			}
	
			// Check if endDate is empty
			if (!endDate || endDate === "") {
				rowErrors.endDate = `${t('common.endDateRequired')}`;
			}

			if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
				rowErrors.startDate = `${t('common.startBeforeEnd')}`;
				//rowErrors.endDate = "End date must be later than start date.";
			}

			// Check for overlapping ranges
			if (startDate && endDate) {
				const currentStart = new Date(startDate);
				const currentEnd = new Date(endDate);
	
				for (let i = 0; i < seenRanges.length; i++) {
					const { start, end, rowIndex } = seenRanges[i];
	
					// Check for overlap
					if (
						(currentStart <= end && currentEnd >= start) || // Overlapping range
						(start <= currentEnd && end >= currentStart)
					) {
						rowErrors.startDate = `${t('common.datesExist')}`;
						newErrors[`row_${rowIndex}`]?.startDate &&
							delete newErrors[`row_${rowIndex}`].startDate; // Clear error on the first occurrence
						break;
					}
				}
	
				// Add the current range to the list of seen ranges
				seenRanges.push({ start: currentStart, end: currentEnd, rowIndex: index });
			}
		
			newErrors[`row_${index}`] = rowErrors;
		});

		setError(newErrors);
		// Add a new row only if there are no errors
		if (!Object.values(newErrors).some((row) => Object.keys(row).length > 0)) {
			updatedOutOfOffice.push('["",""]');
			setData({ ...data, out_of_office: updatedOutOfOffice });
		}
	};
  
	
	// Remove an out of office date range
	const removeOutOfficeInfo = async (index) => {
		const updatedOutOfOffice = [...data.out_of_office];
	  
		if (data.out_of_office.length > 1) {
		  // Remove the selected row
		  const filteredOutOfOffice = updatedOutOfOffice.filter((_, idx) => idx !== index);
		  setData({ ...data, out_of_office: filteredOutOfOffice });
	  
		  // Update errors after removal
		  const updatedError = { ...error };
		  delete updatedError[`row_${index}`];
	  
		  // Shift remaining errors to align with new indices
		  const shiftedErrors = Object.entries(updatedError).reduce((acc, [key, value]) => {
			const rowIndex = parseInt(key.split("_")[1]);
			if (rowIndex > index) {
			  acc[`row_${rowIndex - 1}`] = value;
			} else {
			  acc[key] = value;
			}
			return acc;
		  }, {});
	  
		  setError(shiftedErrors);
		} else {
		  // If only one row remains, clear the out_of_office field
		//   updatedOutOfOffice[0] = '["", ""]';
		updatedOutOfOffice[0] = JSON.stringify(["",""]);

		setData({ ...data, out_of_office: updatedOutOfOffice });
	  
		  // Clear all errors for the reset row
		  setError({});
		}
	};

	/** 
	* To handle all 3 tabs details form submit
	* @e - we get the event details from the form submit action
	**/
	const handleSubmit = async (e) => {
		e.preventDefault();
		// Create local "effective" copies so we can validate/submt immediately
		let effectiveHospitalInfo = hospitalInfo;
		let effectiveParentInfo = parentInfo;
		let effectiveParentInfoForUI = parentInfoForUI;
		if (role === 4 && loadedHospitalData) {
			// Build updated copies with hospital set to loadedHospitalData.id
			effectiveHospitalInfo = (hospitalInfo || []).map((item) => ({ ...item, hospital: loadedHospitalData.id }));
			effectiveParentInfo = (parentInfo || []).map((item) => ({ ...item, hospital: loadedHospitalData.id }));
			effectiveParentInfoForUI = (parentInfoForUI || []).map((item) => ({ ...item, hospital: loadedHospitalData.id }));
			// Update React state asynchronously (don't await) so UI stays in sync
			setHospitalInfo(effectiveHospitalInfo);
			setParentInfo(effectiveParentInfo);
			setParentInfoForUI(effectiveParentInfoForUI);
		}

		  if (role === 3 && loadedHospitalData) {
		
			// Update hospital value for all objects in parentInfo
			const updatedParentInfo = parentInfo.map((item) => ({
				...item,
				hospital: loadedHospitalData.id,
			}));
		
			await setParentInfo(updatedParentInfo); // Update the state
		}
		
		let value = {};
		let seenRanges = [];
		let hasErrors = false;
		const finalErrors = {};
		
		// Check if out_of_office is ["", ""]
		if (data?.out_of_office?.every(entry => entry === '["",""]')) {
			data.out_of_office = []; // Convert to empty array
		} else {
		data.out_of_office.forEach((entry, index) => {
			let startDate = "";
			let endDate = "";
			// Validate that the entry is in the expected format
			if (typeof entry === "string" && entry.startsWith("[") && entry.endsWith("]")) {
				// const dates = entry.replace(/\[|\]/g, "").split(",");

				[startDate, endDate] = entry
					.replace(/\[|\]/g, "")
					.split(",")
					.map((date) => date.trim().replace(/"/g, ""));

				// startDate = dates[0]?.trim();
				// endDate = dates[1]?.trim();
			} else {
				console.error(`Invalid format at index ${index}:`, entry);
				finalErrors[`row_${index}`] = { format: "Invalid date format. Must be [startDate,endDate]" };
				hasErrors = true;
				return; // Skip further processing for this entry
			}
			const rowErrors = {};
		
			// Check if startDate is empty
			if (!startDate || startDate === "") {
				rowErrors.startDate = `${t('common.startDateRequired')}`;
			}

			// Check if endDate is empty
			if (!endDate || endDate === "") {
				rowErrors.endDate = `${t('common.endDateRequired')}`;
			}

			if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
			rowErrors.startDate = `${t('common.startBeforeEnd')}`;
			//rowErrors.endDate = "End date must be later than start date.";
			}
		
			// Check for overlapping ranges
			if (startDate && endDate) {
				const currentStart = new Date(startDate);
				const currentEnd = new Date(endDate);

				for (let i = 0; i < seenRanges.length; i++) {
					const { start, end, rowIndex } = seenRanges[i];

					// Check for overlap
					if (
						(currentStart <= end && currentEnd >= start) || // Overlapping range
						(start <= currentEnd && end >= currentStart)
					) {
						rowErrors.startDate = `${t('common.datesExist')}`;
						finalErrors[`row_${rowIndex}`]?.startDate &&
							delete finalErrors[`row_${rowIndex}`].startDate; // Clear error on the first occurrence
						break;
					}
				}

				// Add the current range to the list of seen ranges
				seenRanges.push({ start: currentStart, end: currentEnd, rowIndex: index });
			}
		
			if (Object.keys(rowErrors).length > 0) {
				setTab(1); // Focus the tab with errors (optional)
				hasErrors = true;
				finalErrors[`row_${index}`] = rowErrors;
			}
		});

		if (hasErrors) {
			setError(finalErrors);
			return;
		}

		}



		// Handle gender and mobile number validation
		data.gender = (data.gender === '0' || data.gender === '1') ? data.gender : '';
		data.mobileNumber = data.mobileNumber || '';
		
		if (!data.countryNameCode && data.mobileNumber) {
			data.countryNameCode = await getCountryCodeFromDialCode(data.countryCode + data.mobileNumber);
		}
	
		// Validate physician data
		const physicianValidationErrors = await validate(data, phyFields);
		if (Object.keys(physicianValidationErrors).length || !isValid) {
			setError(physicianValidationErrors);
			await setTab(0);
			return;
		}
		
		data.gender = (data.gender || data.gender === 0 || data.gender === 1) ? data.gender : null;
		// Get prescription_template from localStorage
		const selectedTemplate = localStorage.getItem('selectedPrescriptionTemplate');
		data.prescription_template = selectedTemplate || null;
		value.physicianInfo = data;
	
		// Merge hospital and parent data for role === 4
		let finalHospitalInfo = effectiveHospitalInfo;
		// Update time zone to systemTimeZone if not changed
		let finalParentInfo = (effectiveParentInfo || []).map((item) => {
			if (item.hospital === '' || item.hospital === null) {
				return { ...item, hospital: "" }; // Ensure hospital is set to an empty string
			}
			return item;
		});
	
		if (role === 4) {
			// Merge parentInfo and parentInfoForUI using the effective copies
			finalParentInfo = [...(effectiveParentInfo || []), ...(effectiveParentInfoForUI || [])].filter(
				(item, index, self) => index === self.findIndex((t) => t.parent === item.parent)
			);
			if (finalParentInfo.length > 0) {
				// keep only entries that have both hospital and parent set (remove empty/placeholder rows)
				finalParentInfo = finalParentInfo.filter(item => (item.hospital && item.hospital !== '') && (item.parent && item.parent !== ''));
			}
		}
	
		// Validate hospital data
		// remove placeholder hospital rows that don't contain any meaningful values
		finalHospitalInfo = finalHospitalInfo.filter(i => (
			(i.hospital && i.hospital !== '') ||
			(i.days && i.days.length > 0) ||
			(i.startTime && i.startTime.trim() !== '') ||
			(i.endTime && i.endTime.trim() !== '') ||
			(i.consultingDuration && i.consultingDuration.trim() !== '')
		));
		const hospitalTab = finalHospitalInfo.map(({ physician, ...remaining }) => Object.keys(remaining).find((key) => remaining[key] !== ''));
		if (!hospitalTab.includes(undefined)) {
			const hospitalValidationErrors = await validate({ 'hospitalInfo': finalHospitalInfo }, hosFields);
			if (Object.keys(hospitalValidationErrors).length) {
				setHospitalError(hospitalValidationErrors);
				toast.error('Hospital validation failed. Please check required fields.');
				await setTab(1);
				return;
			} else {
				// Update time zone to systemTimeZone if not changed
				const sample = (finalHospitalInfo && finalHospitalInfo[0]) || (effectiveHospitalInfo && effectiveHospitalInfo[0]) || {};
				value.hospitalInfo = finalHospitalInfo.map(i => ({
					...i,
					physician: data.account,
					hospital: i.hospital || sample.hospital || '',
					hospital_name: i.hospital_name || sample.hospital_name || '',
					consultingDuration: i.consultingDuration || sample.consultingDuration || '',
					timeZone: i.timeZone || (sample.timeZone ? sample.timeZone : systemTimeZone)
				}));
			}
		} else if (Object.keys(errorHospital).length) {
			setHospitalError(await validate({ 'hospitalInfo': finalHospitalInfo }, hosFields));
			await setTab(1);
			return;
		}
	
		// Validate parent data
		const parentTab = finalParentInfo.map(({ physician, ...remaining }) => Object.keys(remaining).find((key) => remaining[key] !== ''));
		if(role === 4 && !parentTab.includes(undefined)){
			const parentValidationErrors = await validate({ 'parentInfo': finalParentInfo }, parFields);
			if (Object.keys(parentValidationErrors).length || dublicateInfo.length > 0) {
				setParentError(parentValidationErrors);
				toast.error('Parent validation failed. Please check parent entries.');
				return;
			} else {
				// if(parentTab.includes('id')){
					// Ensure physician and hospital fields are present for each parent entry
					value.parentInfo = finalParentInfo
						.filter(item => item && item.parent)
						.map(item => ({
						...item,
						physician: data.account || id,
						hospital: item.hospital || (loadedHospitalData ? loadedHospitalData.id : '')
						}));
				// }
			}
		}
		
		if (role === 3 && !parentTab.includes(undefined)) {
			const parentValidationErrors = await validate({ 'parentInfo': finalParentInfo }, parFields);
			if (Object.keys(parentValidationErrors).length || dublicateInfo.length > 0) {
				setParentError(parentValidationErrors);
				return;
			} else {
				value.parentInfo = finalParentInfo
					.filter(item => item && item.parent)
					.map(item => ({
					...item,
					physician: data.account || id,
					hospital: item.hospital || ''
					}));
				// .map((item) => ({
				// 	hospital: item.hospital || "",
				// 	parent: item.parent,
				// 	physician: id
				// }));
			}
		} 
		else {
			// Remove any empty/placeholder parent entries before final validation
			finalParentInfo = (finalParentInfo || []).filter(item => item && item.parent && String(item.parent).trim() !== '');
			// Re-validate current finalParentInfo instead of trusting possibly stale errorParent state.
			const val = await validate({ 'parentInfo': finalParentInfo }, parFields);
			if (Object.keys(val).length) {
				setParentError(val);
				toast.error('Parent errors exist. Fix them before submitting.');
				return;
			} else {
				// If validation passed and we have valid parents, attach them to payload
				if (finalParentInfo.length) {
					value.parentInfo = finalParentInfo.map(item => ({
						...item,
						physician: data.account || id,
						hospital: item.hospital || ''
					}));
				}
			}
		}
		if (role === 4 && loadedHospitalData) {
			finalParentInfo.forEach(item => {
				item.hospital = loadedHospitalData.id; // Update the hospital property
			});
		}		
		// Submit the data to the API
		// show a brief toast so role 4 clients see the payload being sent
		//toast.info('Submitting physician mapping...');
		const response = await ApiService.physicianMapping(value);
		if (response.status === 200) {
			if (cropImge !== undefined) {
				const formData = new FormData();
				const fileConvertData = await dataURItoBlob(cropImge);
				formData.append('file', fileConvertData);
				await ApiService.uploadNewPhoto(id, formData);
			}
			localStorage.setItem('selectedPrescriptionTemplate',null)
	     	if (role === 3) {
				navigate('/admin/physician');
			} else {
				navigate('/hospital/admin/physician');
			}
			toast.success(response?.data?.message);
		} else {
			toast.error(response?.data?.error[0]?.message || 'Something went wrong');
		}
	};
  

	/** 
	* To handle the image change
	* @e - we get the event details from the input file select action
	**/
	const handleFile = async (e) => {
		e.preventDefault();
		const file = e.target.files[0];
		openCropModal(file);

	}

	/** 
	 * To open the image crop modal
	 * @file - we pass the image details in the base 64 bit format
	 **/
	const openCropModal = async (file) => {

		if (file) {
			let ext = file.name.split('.').pop();
			let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
			if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await setShow(false);
				return;
			}
			if (file.size > 100 * 1024 * 1024) {
				toast.error(t('error.fileSize'));
				await setShow(false);
				return;
			}
			const reader = new FileReader();
			reader.onload = () => { setImage(reader.result) };
			reader.readAsDataURL(file);
			await setShow(true);
		} else {
			await setShow(false);
		}
	}

	/** 
	* To handle event drag
	* @e - we get the event details from the drag over action
	**/
	const handleDrag = (e) => {
		e.preventDefault();
	}

	/** 
	* To handle event drop
	* @e - we get the event details from the drop over action
	**/
	const handleDrop = (e) => {
		e.preventDefault();
		const { files } = e.dataTransfer;
		openCropModal(files[0]);
	}

	//This function is used handle change for hospital and consultingDuration
	const changeHospital = () => (e) => {
		const { value,name } = e.target;
		if(name==="hospital"){
			// Find the selected hospital in the users.hospital array
			const selectedHospital = users?.hospital?.find(hospital => hospital.id === value);

			// Update the hospitalInfo state
			const updatedHospitalInfo = hospitalInfo.map((item, i) => {
				return {
					...item,
					hospital: value, // Update the hospital field
				};
			});

			setHospitalInfo(updatedHospitalInfo);
			// If hospital is selected, clear the error message for that index
			if (value.trim() !== "") {
				setHospitalError((prevErrors) => {
					const updatedErrors = { ...prevErrors };
					delete updatedErrors[`hospitalInfo[0].hospital`]; // Remove the error for this specific hospital field
					return updatedErrors;
				});
			}
		} else if (name==="consultingDuration"){
			// Update consultingDuration in hospitalInfo state
			const updatedHospitalInfo = hospitalInfo.map((item, i) => {
				return {
					...item,
					consultingDuration: value, // Update consultingDuration field
				};
			});
			setHospitalInfo(updatedHospitalInfo);
			// If consultingDuration is selected, clear the error message for that index
			if (value.trim() !== "") {
				setHospitalError((prevErrors) => {
					const updatedErrors = { ...prevErrors };
					delete updatedErrors[`hospitalInfo[0].consultingDuration`]; // Remove the error for this specific consultingDuration field
					return updatedErrors;
				});
			}
		}
		
	};

	//trigger the state
	useEffect(() => {
	}, [hospitalInfo]);

	//components initialize function and api handling
	useEffect(() => {
		(async () => {
			if (id) {
				var response = await ApiService.getPhysician(id);
				var userResponse = await ApiService.getUsersList({ list: ['hospital', 'parent','physician','physician_mapping','parent_mapping'] });
				if (response.status === 200)
					// setData(response.data.item);

				console.log("RESPONSE ITEM ", response?.data?.item?.prescription_template);
				const prescriptionTemplate = response?.data?.item?.prescription_template;
				localStorage.setItem('selectedPrescriptionTemplate',prescriptionTemplate)
					var updatedProfile = { ...response.data.item };
					if (Array.isArray(updatedProfile.out_of_office) && updatedProfile.out_of_office.length === 0) {
					updatedProfile.out_of_office = ['["",""]'];
					}
					setData(updatedProfile);

				response.data.hospitalInfo.length > 0 ? setHospitalInfo(response.data.hospitalInfo) : setHospitalInfo([{ physician: id, hospital: '', days: [], startTime: '', endTime: '' }]);
				if (response.data.parentInfo.length) {
					var { parentInfo } = response.data;
					const uniqueParentInfo = parentInfo.filter((value, index, self) =>
					index === self.findIndex((t) => (
						t.parent === value.parent && t.hospital === value.hospital
					  ))
					);
					response.data.parentInfo = uniqueParentInfo;
					var parentTab = uniqueParentInfo.map(({ parent }) => (parent !== null));
					if (!parentTab.includes(false)) {
						setParentInfo(uniqueParentInfo);
					}
				}
				 // Check `created_by` values and set user if they match
				 if (userResponse.status === 200) {
					const hospitals = userResponse.data.hospital; // Array of hospitals from API response
					const mappings = userResponse.data.physician_mapping; // Array of mappings from API response
	
					const localCreatedBy = localStorage.getItem('created_by'); // Value from local storage
	
					// Filter hospitals to include all matching `created_by` values
					const matchingHospitals = hospitals.filter(hospital => hospital.created_by === localCreatedBy);

					    // Handle non-matching case: Set all hospital data in `setUser`
					const updatedUserData = { ...userResponse.data, hospital: hospitals };

					setUser(updatedUserData);
	
					if (matchingHospitals.length > 0) {
						// Update user data with the full matching hospitals
						const updatedUserData = { ...userResponse.data, hospital: matchingHospitals };
	
						// Ensure setUser receives the correct data
						setUser(updatedUserData);
					} else {
						console.warn('No matching created_by values found. Checking role and mapping.');
	
						// Else condition: Check mappings for `created_by_role === 4` and map to hospital
						const roleBasedMappings = mappings.filter(physician_mapping =>
							physician_mapping.physician_account === id && physician_mapping.created_by_role === 4
						);
	
						// Check if any role-based mapping's `mapped_id` exists in hospital data
						const validHospitals = hospitals.filter(hospital =>
							roleBasedMappings.some(physician_mapping => physician_mapping.mapped_id === hospital.id)
						);
	
	
						if (validHospitals.length > 0) {

							// Remove duplicated parents from parent_mapping
							const uniqueParentMappings = userResponse.data.parent_mapping.reduce((acc, mapping) => {
								// Check if the parent_account already exists in the accumulator
								const existingMappingIndex = acc.findIndex(m => m.parent_account === mapping.parent_account);

								if (existingMappingIndex !== -1) {
									// If it exists, check if the current mapping has a mapped_id and replace the existing one if it doesn't
									if (mapping.mapped_id !== null) {
										acc[existingMappingIndex] = mapping;
									}
								} else {
									// If it doesn't exist, add the current mapping
									acc.push(mapping);
								}

								return acc;
							}, []);

							const filteredParents = userResponse.data.parent.filter(parent =>
								uniqueParentMappings.some(mapping => {
									const isRoleValid = mapping.created_by_role === 4 || mapping.created_by_role === 3;
							
									const isHospitalValid = mapping.mapped_id === null || validHospitals.some(hospital => mapping.mapped_id === hospital.id);
									const isAccountMatching = mapping.parent_account === parent.account;
							
									return isRoleValid && isHospitalValid && isAccountMatching;
								})
							);											
						
							// Update user data with the valid hospitals and filtered parents
							const updatedUserData = {
								...userResponse.data,
								hospital: validHospitals,
								parent: filteredParents,
							};						
						
							setUser(updatedUserData);
						
							if (validHospitals.length === 1) {
								setLoadedHospitalData(updatedUserData.hospital[0]); // Set the state to trigger re-render
							}
						
						} else {
							// console.warn('No matching hospitals found for the role-based mapping.');
						}						
					}
				}						
							
			}

			let hospitalInfoData = response.data.hospitalInfo;
			let uiHospitalInfoData = hospitalInfoData;
			let parentInfoData = response.data.parentInfo;
			let uiParentInfoData = parentInfoData;

			if(role === 4){	
				uiHospitalInfoData = hospitalInfoData.filter(hospital => hospital.hospital === userResponse.data.hospital[0].id);
				hospitalData = userResponse.data.hospital[0];
				setLoadedHospitalData(hospitalData); // Set the state to trigger re-render
				uiParentInfoData = parentInfoData.filter(hospital => hospital.hospital === userResponse.data.hospital[0].id);
				// Set the filtered data for UI rendering

				// uiHospitalInfoData.length > 0 ? setHospitalInfoForUI(uiHospitalInfoData) : setHospitalInfoForUI([{ physician: id, hospital: '', days: [], startTime: '', endTime: '' }]);

				uiParentInfoData.length > 0 ? setParentInfoForUI(uiParentInfoData) : setParentInfoForUI([{ tempId: Date.now(), physician: id, parent: '', hospital: '' }]);
			}
		})();
	}, [id,role]);

	//To handle prescription template selection
	const handlePrescriptionTemplateClick = () => {
		setModal({showPrescriptionTemplate: true});
	};

	//To handle prescription template selection callback
	const handleTemplateSelect = async (selectedTemplate) => {
		try {
			const res = await ApiService.updatePrescriptionTemplate({prescription_template: selectedTemplate});
			if (res.status === 200) {
				toast.success(res?.data?.message)
			}
		} catch (error) {
			console.error("Failed to update template", error);
		}
	};

	//To close modal
	const handleCloseTemplate=()=>setModal({});

	return (
		<main id="main" className="main">
			{/*import ImageCroper*/}
			<ImageCroper
				show={show}
				handleClose={handleClose}
				image={image}
				cropImge={imageData}
			/>
			<AllAppointmentsCancelModal
				show={modalVisible}
				onHide={() => setModalVisible(false)}
				module={modalModule}
				bookedAppointments={bookedAppointments}
				onNo={() => setModalVisible(false)}
				indexValue={indexValue} // Pass the index
				hospitalInfo={hospitalInfo} // Pass hospitalInfo
				setHospitalInfo={setHospitalInfo} // Pass setHospitalInfo
				valueToRemove={valueToRemove} // Pass valueToRemove
				physicianData={data} // Pass data
				setData = {setData} // Pass setData
			/>
			{/*Import SelectedPrescriptionTemplate Modal*/}
			{Object.keys(modal).length !==0 && modal.showPrescriptionTemplate && 
				<SelectedPrescriptionTemplate 
					data={modal} 
					handleClose={handleCloseTemplate} 
					onTemplateSelect={handleTemplateSelect}
					physicianData={data}  // Pass current physician form data
					organizationData={hospitalInfo}  // Pass organization data
				/>
			}
			{/*Page Title Section*/}
			<div className="pagetitle clearfix">
				<div className="float-start">
					<h1>{t('profile.editPhysicianProfile')}</h1>
					<nav>
						<ol className="breadcrumb">
							<li className="breadcrumb-item"><Link to={role === 4 ? '/hospital/admin/dashboard' : '/admin/dashboard'}>{t('sidebar.home')}</Link></li>
							<li className="breadcrumb-item"><Link to={role === 4 ? '/hospital/admin/physician' : '/admin/physician'}>{t('sidebar.physician')}</Link></li>
							<li className="breadcrumb-item active">{t('profile.editPhysicianProfile')} </li>
						</ol>
					</nav>
				</div>
				<div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
				</div>
			</div>
			{/*End Page Title Section*/}

			{/*Page Content Section*/}
			<section>
				<div className="row">
					{/*ProfileImg*/}
					<div className="col-xxl-3">
						<div className="card profile-img">
							<div className="card-body">
								<div className="upload-box d-none d-lg-block">
									<div className="box text-center" onDrop={handleDrop} onDragOver={handleDrag}>
										<input type="file" onChange={handleFile} name="file-6" id="file-6" className="inputfile inputfile-4" />
										<label htmlFor="file-6">
											{cropImge && (<img className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
											{(!cropImge && data && data?.photo && data?.photo === 'default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
											{(!cropImge && data && data?.photo && data?.photo !== 'default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
											<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
										</label>
									</div>
								</div>
								<div className={`text-center ${role === 4 ? 'text-tmAquaGreen' : 'text-tmBlue'} mt-4`}>
									<h6>{t('profile.uploadPicture')}</h6>
								</div>
							</div>
						</div>
					</div>

					{/*Physician Info*/}
					<div className="col-xxl-9">
						<div className={`card form-card profile-info ${role === 4 ? 'admin-profile-info' : ''}`}>
							<div className="card-body pt-4">
								<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(0)} className={tab === 0 ? "nav-link active" : "nav-link"} type="button" role="tab" >{t('profile.physicianInfo')}</span>
									</li>
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(1)} className={tab === 1 ? "nav-link active" : "nav-link"} type="button" role="tab" >{t('profile.hospitalInfo')}</span>
									</li>
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(2)} className={tab === 2 ? "nav-link active" : "nav-link"} type="button" role="tab" >{t('profile.parentInfo')}</span>
									</li>
								</ul>
								<div className="tab-content">
									{/*TAB-01*/}
									{tab === 0 && <div>
										<form autoComplete="off">
											<div className="row">
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label> {t('profile.firstName')} </label>
														<input onChange={handleChange} value={data.first_name ? data.first_name.trim() : ''} name="first_name" type="text" className="form-control" placeholder={t('profile.firstName')} />
														{error && error.first_name && <span className="required">{error.first_name}</span>}
													</div>
												</div>
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label> {t('profile.lastName')} </label>
														<input onChange={handleChange} value={data.last_name ? data.last_name.trim() : ''} name="last_name" type="text" className="form-control" placeholder={t('profile.lastName')} />
														{error && error.last_name && <span className="required">{error.last_name}</span>}
													</div>
												</div>
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label>{t('profile.specialty')}</label>
														<input onChange={handleChange} value={data.specialist ? data.specialist : ''} name="specialist" type="text" className="form-control" placeholder={t('common.enterSpecialty')} />
														{error && error.specialist && <span className="required">{error.specialist}</span>}
													</div>
												</div>
												{/* <div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{constantVariables.profile.department}</label>
														<input onChange={handleChange} value={data.department ? data.department : ''} name="department" type="text" className="form-control" placeholder="Enter The department" />
														{error && error.department && <span className="required">{error.department}</span>}
													</div>
												</div> */}
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.phoneNumber')}</label>
														<PhoneInput
															inputProps={{
																name: 'mobileNumber',
																style: { width: '100%' }
															}}
															country={'us'}
															value={data?.mobileNumberWithCode ? data?.mobileNumberWithCode : ''}
															onChange={handlePhone}
														/>
														{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
														{!isValid && !error.mobileNumber && <span className="required">{t('common.validNumber')}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.emailAddress')}</label>
														<input onChange={handleChange} value={data.email ? data.email : ''} name="email" type="text" className="form-control" placeholder="youremail@mail.com" />
														{error && error.email && <span className="required">{error.email}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.gender')}</label>
														<select name="gender" value={data.gender !== null ? data.gender : ''} onChange={handleChange} className="form-select">
															<option value='' disabled>{t('profile.selectGender')}</option>
															<option value="0">{t('profile.male')}</option>
															<option value="1" >{t('profile.female')}</option>
														</select>
														{error && error.gender && <span className="required">{error.gender}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressOne')}</label>
														<input onChange={handleChange} value={data.address_one ? data.address_one : ''} name="address_one" type="text" className="form-control" placeholder={t('common.addressLine1')} />
														{error && error.address_one && <span className="required">{error.address_one}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressTwo')}</label>
														<input onChange={handleChange} value={data.address_two ? data.address_two : ''} name="address_two" type="text" className="form-control" placeholder={t('common.addressLine2')} />
														{error && error.address_two && <span className="required">{error.address_two}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.city')} </label>
														<Autocomplete
															value={data?.city ? data.city : ''}
															className="form-control"
															placeholder={t('common.city')}
															onChange={changeCity}
															onPlaceSelected={selectCity}
															types={['(cities)']}
														/>
														{error && error.city && <span className="required">{error.city}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.state')} </label>
														<input onChange={handleChange} readOnly value={data.state ? data.state : ''} name="state" type="text" className="form-control" placeholder={t('common.state')} />
														{error && error.state && !data.state && <span className="required">{error.state}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.zipCode')} </label>
														<input onChange={handleChange} value={data.zipcode ? data.zipcode.trim() : ''} name="zipcode" type="text" className="form-control" placeholder={t('common.zipCode')} />
														{error && error.zipcode && <span className="required">{error.zipcode}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>Registration Number </label>
														<input onChange={handleChange}  value={data.register_number?data.register_number:''} name="register_number" type="text" className="form-control" placeholder="Enter the Registration Number" />
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row mt-3">
												<div className="col-lg-6 text-start">
													<Button
														variant={`btn btn-sm ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`}
														className="ms-3"
														onClick={handlePrescriptionTemplateClick}
														>
														<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="me-2" style={ {marginBottom: '3px'}} viewBox="0 0 16 16">
															<path d="M9.243 1.828a1 1 0 0 0-2.486 0l-.28.853a5.982 5.982 0 0 0-1.003.582l-.857-.286a1 1 0 0 0-.95.316l-.707.707a1 1 0 0 0 .316.95l.286.857a5.982 5.982 0 0 0-.582 1.003l-.853.28a1 1 0 0 0 0 2.486l.853.28a5.982 5.982 0 0 0 .582 1.003l-.286.857a1 1 0 0 0 .316.95l.707.707a1 1 0 0 0 .95.316l.857-.286a5.982 5.982 0 0 0 1.003.582l.28.853a1 1 0 0 0 2.486 0l.28-.853a5.982 5.982 0 0 0 1.003-.582l.857.286a1 1 0 0 0 .95-.316l.707-.707a1 1 0 0 0-.316-.95l-.286-.857a5.982 5.982 0 0 0 .582-1.003l.853-.28a1 1 0 0 0 0-2.486l-.853-.28a5.982 5.982 0 0 0-.582-1.003l.286-.857a1 1 0 0 0-.316-.95l-.707-.707a1 1 0 0 0-.95-.316l-.857.286a5.982 5.982 0 0 0-1.003-.582l-.28-.853zM8 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
														</svg>
														{t('modal.selectPrescriptionTemplate')}
													</Button>	
												</div>	
												<div className="col-lg-12 text-end">
													<button type="button" onClick={navChange(0)} className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'} btnNext`}><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}

									{/*TAB-02*/}
									{tab === 1 && <div>
										<form>
											<div className="row">
												<div className="col-lg-12">
													<div className="form-group row">
														<div className="col-lg-6 col-md-6 mb-3"> 
															<label>{t('profile.hospitalName')} </label>
															{/* <select name="hospital" value={role === 4 ? hospitalInfo[1]?.hospital : hospitalInfo && hospitalInfo[0]?.hospital} className="form-select" 
															onChange={changeHospital()} disabled={role === 4}
															>
																<option value="" disabled>-- Select Hospital --</option>
																{users?.hospital?.map((hospital) => (
																	<option key={hospital.id} value={hospital.id}>
																		{hospital.name}
																	</option>
																))}
															</select> */}
															<Select
																value={
																	role === 4
																	? {
																		value: loadedHospitalData?.id, // Use id from loadedHospitalData
																		label: loadedHospitalData?.name, // Use name from loadedHospitalData
																	  } || null // Default to null if no data
																	:
																	users?.hospital?.length === 1
																	? {
																		  value: users?.hospital[0]?.id, // Prefill single option value
																		  label: users?.hospital[0]?.name,
																	  }: 
																	users?.hospital
																		?.filter(
																			(hospital) =>
																			hospital.id === hospitalInfo[0]?.hospital
																		)
																		?.map((hospital) => ({
																			value: hospital.id,
																			label: hospital.name,
																		}))[0] || null // Match based on hospitalInfo for other roles
																}
																options={
																	users?.hospital?.map((hospital) => ({
																	value: hospital.id,
																	label: hospital.name,
																	})) || []
																}
																onChange={(selectedOption) => {
																	if (users?.hospital?.length > 1) {
																		// Trigger change for user selection when multiple hospitals exist
																		changeHospital()({
																			target: { name: "hospital", value: selectedOption?.value },
																		});
																	} else {
																		// Automatically update state when there is only one hospital available
																		const selectedHospital = users?.hospital[0]; // Get the single available hospital
																		const updatedHospitalInfo = hospitalInfo.map((item) => {
																			return {
																				...item,
																				hospital: selectedHospital.id, // Update the hospital info state with the id
																			};
																		});
																		setHospitalInfo(updatedHospitalInfo); // Update state with the selected hospital
																	}
																}}
																placeholder={t('common.selectHospital')}
																classNamePrefix="react-select"
																isDisabled={role === 4 ||  (role !== 4 && users?.hospital?.length === 1)}
																/>

															{/* {errorHospital && errorHospital?.hospital && role!==4 &&<span className="required">{errorHospital.hospital}</span>} */}
															{errorHospital && errorHospital[`hospitalInfo[0].hospital`] && role!==4 && (
																<span className="required">{errorHospital[`hospitalInfo[0].hospital`]}</span>
															)}
														</div>
														<div className="col-lg-6 col-md-4 mb-3">
															<label>{t('profile.timeZone')}</label>
															<div>
																<TimezoneSelect
																	name="timeZone"
																	value={hospitalInfo && hospitalInfo[0]?.timeZone ? hospitalInfo[0]?.timeZone : systemTimeZone}
																	onChange={(value) => changeTimeZone(value)}
																	labelStyle="altName"
																/>
															</div>
															{errorHospital && (errorHospital['hospitalInfo.timeZone']) && <span className="required">{(errorHospital['hospitalInfo.timeZone'])}</span>}
														</div>
														<div className="row">
															<div className="col-xxl-12">
																<div className="secTitle">
																	<h1>{t('table.appointmentSettings')}</h1>
																</div>
															</div>
														</div>
														{/* Consulting Duration */}
														<div className="row">
														<div className="col-lg-4 col-md-6 mb-3">
															<label>{t('table.consultingDuration')} </label>
															<select
																className="form-select"
																name="consultingDuration"
																value={hospitalInfo &&hospitalInfo[0]?.consultingDuration || ''}
																onChange={changeHospital()}
															>
																<option value="" disabled>{t('profile.selectConsultingDuration')}</option>
																<option value="10">10 {t('common.mins')}</option>
																<option value="15">15 {t('common.mins')}</option>
																<option value="20">20 {t('common.mins')}</option>
																<option value="25">25 {t('common.mins')}</option>
																<option value="30">30 {t('common.mins')}</option>
															</select>
															{/* {errorHospital && errorHospital?.consultingDuration && <span className="required">{errorHospital.consultingDuration}</span>} */}
															{errorHospital && errorHospital[`hospitalInfo[0].consultingDuration`] &&  (
																<span className="required">{errorHospital[`hospitalInfo[0].consultingDuration`]}</span>
															)}
														</div>
														</div>
														{hospitalInfo
														// .filter(item => (role === 4 ? item.hospital === users?.hospital[0].id : true))
														.map((item, i) => (
														<div className="row" key={i}>
														<div className="col-lg-7 col-md-6 mb-3">
															<label> {t('common.visitingDays')} </label>
															<div className="form-group mb-0 checkRadio-bg">
																{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, idx) => (
																	<div key={idx} className="form-check form-check-inline">
																		<input
																			className={`form-check-input ${role === 4 ? 'days_hospitalAdmin' : 'days_Admin'}`}
																			type="checkbox"
																			name="DaysOptions"
																			value={day}
																			checked={hospitalInfo[i].days.includes(day)}
																			onChange={changeHospitalInfo(i)}
																		/>
																		<label className="form-check-label">  {t(`common.${day.slice(0, 2).toLowerCase()}`)}</label>
																	</div>
																))}
															</div>
															{errorHospital && errorHospital[`hospitalInfo[${i}].days`] && (
																<span className="required">{errorHospital[`hospitalInfo[${i}].days`]}</span>
															)}
														</div>
														<div className="col-lg-5 col-md-4 mb-3">
															<label>{t('profile.visitingHours')}</label>
															<div className="d-flex">
																<div>
																	<DatePicker format="hh:mm aa" value={convertTimeToDate(item.startTime)}
																		showMeridian
																		onSelect={(selectedTime) => {
																			if (moment(selectedTime, "hh:mm A", true).isValid()) {
																				changeVistingTime(selectedTime, i, "startTime");
																			} else {
																				console.error("Invalid time selected:", selectedTime);
																			}
																		}}	
																		onKeyDown={(event) => {
																			if (event.key === "Enter") {
																				const inputValue = event.target.value.trim(); // Trim to handle stray spaces
																				if (moment(inputValue, "hh:mm A", true).isValid()) {
																					changeVistingTime(inputValue, i, "startTime");
																				} else {
																					console.error("Invalid time entered:", inputValue);
																				}
																			}
																		}}
																		name="startTime"
																		cleanable={false}
																	/>

																	{errorHospital && (errorHospital['hospitalInfo[' + i + '].startTime']) && <span className="required mt-1 d-block">{(errorHospital['hospitalInfo[' + i + '].startTime'])}</span>}
																</div>
																<div className="my-2 mx-3"> - </div>
																<div>
																	<DatePicker format="hh:mm aa" value={convertTimeToDate(item.endTime)}
																		showMeridian
																		onSelect={(selectedTime) => {
																			if (moment(selectedTime, "hh:mm A", true).isValid()) {
																				changeVistingTime(selectedTime, i, "endTime");
																			} else {
																				console.error("Invalid time selected:", selectedTime);
																			}
																		}}	
																		onKeyDown={(event) => {
																			if (event.key === "Enter") {
																				const inputValue = event.target.value.trim(); // Trim to handle stray spaces
																				if (moment(inputValue, "hh:mm A", true).isValid()) {
																					changeVistingTime(inputValue, i, "endTime");
																				} else {
																					console.error("Invalid time entered:", inputValue);
																				}
																			}
																		}}
																		name="endTime"
																		cleanable={false}
																	/>
																	{errorHospital && (errorHospital['hospitalInfo[' + i + '].endTime']) && <span className="required mt-1 d-block">{(errorHospital['hospitalInfo[' + i + '].endTime'])}</span>}
																</div>
															</div>
														</div>
														
															{/*  Display the overlap error */}
															{errorHospital && errorHospital[`hospitalInfo[${i}].overlap`] && (
																<span className="required">{errorHospital[`hospitalInfo[${i}].overlap`]}</span>
															)}
														<div className="col-lg-1 col-md-2  mb-3">
															<label>&nbsp; </label>
															<div className="d-flex">
																<button onClick={removeHospitalInfo(i)} type="button" className="btn btn-outline-danger py-2"><i className="ri-close-fill"></i></button>
																{hospitalInfo.length && hospitalInfo.length - 1 === i && ( <button onClick={addHospitalInfo(i)} type="button" className={`btn ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} py-2 mx-2`}><i className="ri-add-fill align-middle"></i></button>)}
															</div>
														</div>
													</div>))}
													</div>
												</div>
												<div className="row mt-4">
													<div className="col-xxl-12">
														<div className="secTitle">
															<h1>{t('profile.outOfOffice')}</h1>
														</div>
													</div>
												</div>
												<div className="row">
												{(Array.isArray(data?.out_of_office) && data?.out_of_office.length > 0 
													? data?.out_of_office 
													: [["",""]]).map((item, index) => {
													
													// Initialize startDate and endDate
													let startDate = "";
													let endDate = "";

													// Check the format of the item and parse accordingly
													if (Array.isArray(item)) {
														startDate = item[0]?.trim() || "";
														endDate = item[1]?.trim() || "";
													} else if (typeof item === "string") {
														const dates = item.replace(/\[|\]/g, "").split(",");
														startDate = dates[0]?.trim() || "";
														endDate = dates[1]?.trim() || "";
													}
													
													// Helper to format dates for input type="date"
													const formatInputDate = (date) => {
														const d = new Date(date);
														return isNaN(d) || !date ? "" : d.toISOString().split("T")[0]; // Empty string if date is invalid or null
													};

													const formattedStartDate = formatInputDate(startDate);
													const formattedEndDate = formatInputDate(endDate);

													// Get the errors for this row
													const rowErrors = error[`row_${index}`] || {};
													const isPlaceholder = data?.out_of_office.length === 0;	

													return (
													<div className="row mb-3" key={index}>
														{/* Start Date Field */}								
															{/* <input
																type="date"																
																min={new Date().toISOString().split("T")[0]}
																name="start_date"
																className="form-control"
																onChange={(e) =>
																	changeOutOfOfficeInfo(index, "startDate", e.target.value)
																}
																value={formattedStartDate} // Bind parsed startDate
															/> */}											
														<div className={`col-lg-3 col-md-6 ${
															role === 4  ? 'admin-flatpicker' : 'flatpicker'
														}`}>
															<label>{t('modal.startDate')}</label>
															<div className="input-group">
																<Flatpickr
																value={formattedStartDate} // Bind the selected date
																onChange={(selectedDates) =>
																	changeOutOfOfficeInfo(index, "startDate", selectedDates[0])
																}
																options={{
																	dateFormat: "Y-m-d", // Format of the date
																	minDate: "today", // Minimum date as today
																}}
																placeholder={t('profile.selectDate')} // Placeholder text
																className="form-control" // Optional: Add a CSS class
																ref={(el) => (startflatpickrRef.current[index] = el)} // Correctly set ref
																/>
																{/* Calendar Icon */}
																<span className="input-group-text input-button" title="toggle"
																onClick={() => startflatpickrRef.current[index]?.flatpickr?.open()}>
																	<i className="ri-calendar-line"></i>
																</span>
															</div>
															{/* Error Message */}
															{rowErrors && rowErrors.startDate && (
																<div className="text-danger">{rowErrors.startDate}</div>
															)}
														</div>
																											
														{/* End Date Field */}
														<div className={`col-lg-3 col-md-6 ${
															role === 4  ? 'admin-flatpicker' : 'flatpicker'
														}`}>
															<label>{t('modal.endDate')}</label>
															{/* <input
																type="date"									
																min={new Date().toISOString().split("T")[0]}
																name="end_date"
																className="form-control"
																onChange={(e) =>
																	changeOutOfOfficeInfo(index, "endDate", e.target.value)
																}
																value={formattedEndDate} // Bind parsed endDate
															/> */}
															<div className="input-group">
																<Flatpickr
																value={formattedEndDate} // Bind the selected date
																onChange={(selectedDates) =>
																	changeOutOfOfficeInfo(index, "endDate", selectedDates[0])
																}
																options={{
																	dateFormat: "Y-m-d", // Format of the date
																	minDate: "today", // Minimum date as today
																}}
																placeholder={t('profile.selectDate')} // Placeholder text
																className="form-control" // Optional: Add a CSS class
																ref={(el) => (endflatpickrRef.current[index] = el)} // Correctly set ref
																/>
																{/* Calendar Icon */}
																<span className="input-group-text input-button" title="toggle"
																onClick={() => endflatpickrRef.current[index]?.flatpickr?.open()}>
																	<i className="ri-calendar-line"></i>
																</span>
															</div>
															{rowErrors && rowErrors.endDate && (
																<div className="text-danger">{rowErrors.endDate}</div>
															)}
														</div>
													
														{/* Buttons */}
														<div className="col-lg-6 d-flex align-items-center">
															<label>&nbsp;</label>
															<div>
																<button
																	type="button"
																	className="btn btn-outline-danger py-2 me-2 mt-4"
																	onClick={() => removeOutOfficeInfo(index)}
																>
																	<i className="ri-close-fill"></i> {t('common.remove')}
																</button>
																{(isPlaceholder || data?.out_of_office.length - 1 === index) && (
																	<button
																		type="button"
																		className={`btn ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} py-2 mt-4`}
																		onClick={addOutOfficeInfo}
																	>
																		<i className="ri-add-fill align-middle"></i>  {t('common.addMore')}
																	</button>
																)}
															</div>
														</div>
													</div>
													
													);
												})}
											</div>
											</div>

											{/*Prev-Next Button Section*/}
											<div className="row mt-3">
												<div className="col-lg-12 text-end">
													<button onClick={() => setTab(0)} type="button" className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-secondary'} btnPrev me-2`}><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={navChange(1)} type="button" className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'} btnNext`}><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}

																		{/*TAB-03*/}
									{tab === 2 && <div>
										<form>
											<div className="row">
												<div className="col-lg-12">
													{/* Unified Mapped Parents Layout (no accordion needed) */}
													<div>
														<div className="secTitle mb-3">
															<h1>{t('common.mappedParents')}</h1>
														</div>
														<div className="table-responsive">
															<div className="d-flex justify-content-between align-items-center mb-3">
																<div className="d-flex align-items-center">
																	<input
																		type="text"
																		className="form-control me-3"
																		placeholder={t('common.search') + ' ' + t('profile.parentName')}
																		value={mappedParentsTable.search}
																		onChange={handleMappedParentsSearch}
																	/>
																</div>
																<button
																	type="button"
																	className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`}
																	onClick={() => setShowAddParentModal(true)}
																>
																	<i className="ri-add-fill align-middle me-2"></i>
																	{t('common.addParent')}
																</button>
															</div>
															<table className="table table-borderless theme-table">
																<thead>
																	<tr>
																		<th className="text-center">S.No</th>
																		<th className="text-center">{t('profile.parentName')}</th>
																		<th className="text-center">{t('table.member')}</th>
																		<th className="text-center">{t('profile.action')}</th>
																	</tr>
																</thead>
																<tbody>
																	{getMappedParents().parents.map((parent, index) => (
																		<tr key={parent.account}>
																			<td className="text-center">{(mappedParentsTable.page * mappedParentsTable.limit) + index + 1}</td>
																			<td className="text-center">{parent.first_name} {parent.last_name}</td>
																			<td className="text-center">
																				{Array.isArray(parent.member_details) && parent.member_details.length > 0 ? (
																					parent.member_details.map((m, mi) => (
																						<div key={m.id || mi} className="child-name text-center small">{m.name}</div>
																					))
																				) : (
																					<div className="small text-center">-</div>
																				)}
																			</td>
																			<td className="text-center">
																				<button
																					type="button"
																					className="btn btn-sm btn-outline-danger"
																					onClick={() => removeMappedParent(parent.account)}
																					title={t('common.remove')}
																				>
																					<i className="ri-close-fill"></i>
																				</button>
																			</td>
																		</tr>
																	))}
																		{getMappedParents().parents.length === 0 && (
																			<tr>
																				<td colSpan="4" className="text-center">{t('common.noRecord')}</td>
																			</tr>
																		)}
																</tbody>
															</table>
															{/* Pagination */}
															{getMappedParents().total > 0 && (
																<div className="d-flex justify-content-center">
																	<Pagination
																		page={getMappedParents().page}
																		handlePaginate={handleMappedParentsPaginate}
																		total={getMappedParents().total}
																		limit={getMappedParents().limit}
																	/>
																</div>
															)}
														</div>
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">
												<div className="col-lg-6 text-start">
													<button onClick={() => setTab(1)} type="button" className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-secondary'} btnPrev me-2`}><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
												</div>
												<div className="col-lg-6 text-end">
													<button type="button" onClick={handleSubmit} className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`} ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
												</div>
											</div>
										</form>
									</div>}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* End Page Content Section */}

			{/* Add Parent Modal */}
			<Modal show={showAddParentModal} onHide={() => setShowAddParentModal(false)} size="lg">
				<Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
					<Modal.Title>{t('common.addParent')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<div className="d-flex justify-content-between align-items-center mb-3">
							<div className="d-flex align-items-center">
								<input
									type="text"
									className="form-control me-3"
									placeholder={t('common.search') + ' ' + t('profile.parentName')}
									value={unmappedParentsTable.search}
									onChange={handleUnmappedParentsSearch}
								/>
							</div>
						</div>
						<table className="table table-borderless theme-table">
							<thead>
								<tr>
									<th className="text-center">S.No</th>
									<th className="text-center">{t('profile.parentName')}</th>
									<th className="text-center">{t('table.member')}</th>
									<th className="text-center">{t('common.select')}</th>
								</tr>
							</thead>
							<tbody>
								{getUnmappedParents().parents.map((parent, index) => (
									<tr key={parent.account}>
										<td className="text-center">{(unmappedParentsTable.page * unmappedParentsTable.limit) + index + 1}</td>
										<td className="text-center">{parent.first_name} {parent.last_name}</td>
										<td className="text-center">
											{Array.isArray(parent.member_details) && parent.member_details.length > 0 ? (
												parent.member_details.map((m, mi) => (
													<div key={m.id || mi} className="child-name text-center small">{m.name}</div>
												))
											) : (
												<div className="small text-center">-</div>
											)}
										</td>
										<td className="text-center">
											<input
												type="checkbox"
												className="form-check-input"
												checked={selectedUnmappedParents.includes(parent.account)}
												onChange={(e) => toggleUnmappedParentSelection(parent.account, e.target.checked)}
											/>
										</td>
									</tr>
								))}
								{getUnmappedParents().parents.length === 0 && (
									<tr>
										<td colSpan="4" className="text-center">
											{unmappedParentsTable.search
												? t('common.noRecord')
												: t('common.typeToSearchParents')}
										</td>
									</tr>
								)}
							</tbody>
						</table>
						{/* Pagination */}
						{getUnmappedParents().total > 0 && (
							<div className="d-flex justify-content-center">
								<Pagination
									page={getUnmappedParents().page}
									handlePaginate={handleUnmappedParentsPaginate}
									total={getUnmappedParents().total}
									limit={getUnmappedParents().limit}
								/>
							</div>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowAddParentModal(false)} className={`${role === 4 ? 'btn-tmAquaDgreen' : ''}`}> 
						{t('modal.close')}
					</Button>
					<Button 
						variant="primary" 
						onClick={addSelectedParents}
						disabled={selectedUnmappedParents.length === 0}
						className={`${role === 4 ? 'btn-tmAquaGreen' : ''}`} 
					>
						{t('modal.update')}
					</Button>
				</Modal.Footer>
			</Modal>

		</main>
	);
};

export default EditPhysician;